import {
  Cctv, MonitorPlay, Radar, ShieldCheck, Server, GraduationCap, Landmark, Shield, Siren,
  BookOpen, Ship, Factory, PencilRuler, PackageCheck, Wrench, Headset, Workflow, Award,
  Handshake, Layers, Cpu, Network, Camera, Building2,
} from "lucide-react";

const MAP = {
  Cctv, MonitorPlay, Radar, ShieldCheck, Server, GraduationCap, Landmark, Shield, Siren,
  BookOpen, Ship, Factory, PencilRuler, PackageCheck, Wrench, Headset, Workflow, Award,
  Handshake, Layers, Cpu, Network, Camera, Building2,
};

export default function iconFor(name) {
  return MAP[name] || Layers;
}
